/* eslint-disable max-nested-callbacks */
import React, { useContext, useState, useEffect, useMemo, useCallback, useRef } from "react";
import api from "../../api";
import contextMenus, { Names } from "../../contextMenus";
import events from "../../context/events";
import ContextMenu, { IContextRender } from "../../components/List/ContextMenu";
import { Order, Sort } from "../../components/List/Filters/config";
import { folderType, folderTypeEnum } from "../../config/permissions.config";
import { connect } from "dvajs";
import { JoyspaceState } from "@/models/joyspace";
import { useHistory } from "react-router-dom";
import CardList from "../../components/CardList";
import { useListData } from "../../components/TableList/Use/useListData";
import { ContextMenuMode, MenusType } from "../../types";
interface IProps {
  getFolderInfoById: Function;
  currentRouterInfo: any;
}
const key = MenusType.SPACE;
function PageList(props: IProps) {
  const { getFolderInfoById, currentRouterInfo } = props;
  const [useList, setUseList] = useState<any[]>([]);
  const [isLoadMore, setLoadMore] = useState<boolean>(false);
  const [isMySpace, setIsMySpacePage] = useState<boolean>(false);
  const [defalutSpaceId, setDefalutSpaceId] = useState<folderType | null>(null);
  const getFolderList = async (spaceId: string) => {
    let folderList = await getFolderInfoById(spaceId, {
      order: Order.DESC,
      sort: Sort.UpDateTime
    });
    folderList = (folderList || []).map((item: any) => {
      item.title = item.name || "无标题";
      item.isFolder = true;
      return item;
    });
    if (folderList.length > 9) {
      setLoadMore(true);
    } else {
      setLoadMore(false);
    }
    return folderList;
  };
  const { list, loading } = useListData({
    key,
    isFilter: false,
    requestCategoriesuFunc: getFolderList
  });
  useEffect(() => {
    if (list.length <= 0) {
      setUseList([]);
      return;
    }
    if (isLoadMore) {
      setUseList(list.slice(0, 9));
      return;
    }
    setUseList([...list]);
  }, [list, isLoadMore]);
  const history = useHistory();

  useEffect(() => {
    if (!currentRouterInfo) {
      console.warn("currentRouterInfo_null_Error");
      return;
    }
    setIsMySpacePage(currentRouterInfo.type !== folderTypeEnum.SHARE);
    if (currentRouterInfo.type === folderTypeEnum.SHARE && defalutSpaceId !== folderType.SHARE) {
      setDefalutSpaceId(folderType.SHARE);
      return;
    }
    if (currentRouterInfo.type === folderTypeEnum.MY && defalutSpaceId !== folderType.MY) {
      setDefalutSpaceId(folderType.MY);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentRouterInfo]);

  const openPage = (e: any, item: any) => {
    const path = item.type === folderTypeEnum.SHARE ? `teamspace` : "myspace";
    history.push(`/joyspace/${path}?categoryId=${item.id}`);
  };
  const onButtom = useCallback(() => {
    if (isLoadMore) {
      setLoadMore(false);
    }
  }, [isLoadMore]);
  const setData = useCallback((data: any) => {
    events.emit("list.partial.refresh", {
      changeData: data,
      key
    });
  }, []);
  useEffect(() => {
    events.on("card-setData", setData);
    return () => {
      events.off("card-setData", setData);
    };
  }, [setData]);
  const renderActions = useCallback(
    (item: any, contextMenuMode = ContextMenuMode.Click) => {
      return (
        <ContextMenu
          render={contextMenus.category(isMySpace ? "MY_SPACE" : "TEAM_SPACE", currentRouterInfo)}
          callbackProps={{
            contextMenuMode,
            data: item,
            originId: currentRouterInfo?.id,
            setData,
            remove: () => {
              console.log("remove");
            },
            reload: () => {
              console.log("reload");
            }
          }}
        />
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentRouterInfo, isMySpace, list]
  );

  return (
    <CardList
      title={isMySpace ? "文件夹" : "共享文件夹"}
      emptyText="暂无文件夹，拖拽文件夹上传或点击“新建”创建文件夹"
      list={useList}
      loading={loading}
      isLoadMore={isLoadMore}
      callback={openPage}
      isCollectedShow={true}
      allowDraggble={true}
      renderActions={renderActions}
      onButtom={onButtom}
    />
  );
}

function mapStateToProps({ joyspace }: { joyspace: JoyspaceState }) {
  return {
    currentRouterInfo: joyspace.currentRouterInfo
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    getFolderInfoById(id: any, params: any) {
      return dispatch({
        type: "joyspace/freshFolderTreeById",
        payload: {
          id,
          params
        }
      });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(PageList);
